<ra-modal
    [title]="('document.edit.documentConfig.saveScopeTitle' | translate)"
    [size]="'small'"
    [disabled]="loading()"
    (close)="close.emit()">

    <div class="options-card">
        @for (option of options(); track option.scope) {
            <button
                type="button"
                class="option-row option-row--button"
                [disabled]="loading()"
                (click)="scopeSelected.emit(option.scope)">
                <div class="option-text">
                    <span class="option-title">{{ option.titleKey | translate }}</span>
                    <span class="option-description">{{ option.descriptionKey | translate }}</span>
                </div>
                <ra-icon icon="arrow-right" varColor="contentSecondary" [size]="18" />
            </button>
        }
    </div>
</ra-modal>
